import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {ConfigService, initializeJam, initializeSentry} from '@q9elements/ui-kit/common';

import {AppModule} from './app/app.module';

const ignoreErrors = [
  'unauthorized',
  'no_password',
  'authentication_failed',
  'The database connection is closing',
  'A network error (such as timeout, interrupted connection or unreachable host) has occurred.\n',
  'Unspecified error.',
  'ChunkLoadError: Loading chunk',
  'permission_denied at /users'
];

if (ConfigService.environment.production) {
  enableProdMode();
  initializeSentry(ignoreErrors);
  initializeJam();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
